export const categoriesConfig = [
  {
    key: "asset",
    name: "Asset",
    params: [
      "maturity",
      "projectRisk",
      "historicalRisk",
      "concentration",
      "regulatoryCompliance",
      "amlCompliance",
      "foundersTeam",
      "reputation",
      "lawsuits",
    ],
  },
  {
    key: "blockchain",
    name: "Blockchain",
    params: [
      "maturity",
      "projectRisk",
      "historicalRisk",
      "concentration",
      "regulatoryCompliance",
      "amlCompliance",
      "foundersTeam",
      "reputation",
      "lawsuits",
    ],
  },
  {
    key: "stakingPlatform",
    name: "Staking Platform",
    params: [
      "maturity",
      "security",
      "historicalSecurityRisk",
      "historicalSlashingRisk",
      "decentralization",
      "regulatoryCompliance",
      "amlCompliance",
      "foundersTeam",
      "reputation",
      "legalStanding",
      "uptime",
    ],
  },
  {
    key: "validator",
    name: "Validator",
    params: [
      "maturity",
      "security",
      "historicalSecurityRisk",
      "historicalSlashingRisk",
      "decentralization",
      "regulatoryCompliance",
      "amlCompliance",
      "foundersTeam",
      "reputation",
      "legalStanding",
      "uptime",
    ],
  },
  {
    key: "stakingMechanism",
    name: "Staking Mechanism",
    params: ["stakingMechanismRisk"],
  },
  { key: "slashing", name: "Slashing", params: ["slashingRisk"] },
  { key: "liquidity", name: "Liquidity", params: ["liquidityRisk"] },
  {
    key: "stakedValue",
    name: "Staked Value",
    params: ["stakedValueRisk", "stakedAmount"],
  },
  { key: "tvl", name: "TVL", params: ["tvlRisk"] },
  {
    key: "stakingByCompetitors",
    name: "Staking by Competitors",
    params: ["competitorsRisk"],
  },
  {
    key: "stakingProcedure",
    name: "Staking Procedure",
    params: ["procedureRisk"],
  },
];

export const getValueColor = (optionValue, itemKey) => {
  if (itemKey === "uptime" && optionValue === "High") {
    return "#4dc7b5"; // green
  }

  const highRiskValues = [
    "High",
    "Immature",
    "Unreliable",
    "Negative",
    "Lawsuits Exist",
    "AML Activities",
    "Non-Compliant",
    "Limited",
    "Centralized",
  ];

  const mediumRiskValues = ["Medium", "Anonymous", "Standard", "Not FI", "Moderate Compliance"];

  if (highRiskValues.includes(optionValue)) return "#F27281"; // red
  if (mediumRiskValues.includes(optionValue)) return "#EFB661"; // orange

  return "#4dc7b5"; // green
};

const BASE_CIRCLE_PROPS = {
  fontSize: "1.625em",
  fontWeight: 900,
  size: 80,
  boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
  unit: "",
  textPosition: "0.35em",
  animationOff: false,
  inverse: false,
  round: true,
  number: false,
};

const createCircleProps = (percent, color) => ({
  ...BASE_CIRCLE_PROPS,
  percent: Math.round(percent ?? 0),
  colorSlice: color,
  fontColor: color,
});

export const renderClassName = (safetyIndex) => {
  const coldProps = createCircleProps(safetyIndex, "#4DC7B5");
  const riskProps = createCircleProps(safetyIndex, "#EFB661");
  const holdProps = createCircleProps(safetyIndex, "#F27281");
  const whiteProps = createCircleProps(0, "#f0f0f3");
  if (safetyIndex >= 65 && safetyIndex <= 100) {
    return {
      className: "card cold defi", // green
      color: "#4dc7b5",
      props: coldProps,
    };
  } else if (safetyIndex >= 31 && safetyIndex <= 64) {
    return {
      className: "card hold defi", // yellow
      color: "#EFB661",
      props: riskProps,
    };
  } else if (safetyIndex >= 0 && safetyIndex < 31) {
    return {
      className: "card risky defi", // red
      color: "#F27281",
      props: holdProps,
    };
  } else {
    return {
      className: "card empty defi",
      color: "#C4C4C4",
      props: whiteProps,
    };
  }
};
